import clsx from "clsx";

interface InfoPageListProps {
  as?: "ul" | "ol";
  className?: string;
  children: React.ReactNode;
}

export const InfoPageList = ({ as = "ul", className, children }: InfoPageListProps) => {
  const Component = as;
  const listClasses = as === "ol" ? "list-decimal" : "list-disc";

  return (
    <Component className={clsx("list-outside space-y-2 pl-4 text-base", listClasses, className)}>
      {children}
    </Component>
  );
};

interface InfoPageListItemProps {
  className?: string;
  children: React.ReactNode;
}

export const InfoPageListItem = ({ children, className }: InfoPageListItemProps) => {
  return <li className={clsx("leading-[1.7] lg:pl-2", className)}>{children}</li>;
};
